import React from "react";
import { Box, Typography, Container } from "@mui/material";

const TermsAndConditionsPage = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: "#f4f6f8" }}>
      <Container maxWidth="md">

        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontSize: { xs: "1.6rem", sm: "2rem", md: "2.5rem" },
            fontWeight: "bold",
            color: "#222",
            mb: 3,
          }}
        >
          Términos y Condiciones – FactuSysDR
        </Typography>

        <Typography sx={{ mb: 4, color: "#555" }}>
          El uso del sistema FactuSysDR implica la aceptación de los presentes
          términos y condiciones del servicio de facturación electrónica.
        </Typography>

        <Section
          title="1. Naturaleza del servicio"
          text="FactuSysDR es una plataforma tecnológica en modalidad SaaS que permite la gestión de documentos electrónicos autorizados por el Servicio de Rentas Internas (SRI)."
        />

        <Section
          title="2. Responsabilidad sobre el SRI"
          text="FactuSysDR no es responsable por interrupciones, rechazos, demoras o indisponibilidad del sistema del SRI, ya que corresponden a servicios externos fuera de nuestro control."
        />

        <Section
          title="3. Cancelación del servicio"
          text="La cancelación del plan deberá solicitarse con al menos 15 días de anticipación. Durante este período el usuario podrá descargar su información. Finalizado el servicio el acceso será suspendido."
        />

        <Section
          title="4. Respaldo de información"
          text="El usuario es responsable de descargar su información antes de la cancelación del servicio. FactuSysDR no garantiza almacenamiento indefinido posterior a la terminación."
        />

        <Section
          title="5. Mejoras del sistema"
          text="FactuSysDR podrá implementar mejoras técnicas y nuevas funcionalidades sin costo adicional para los clientes activos."
        />

        <Section
          title="6. Funcionalidades personalizadas"
          text="El desarrollo de integraciones especiales, soporte técnico avanzado o funcionalidades adicionales podrá realizarse bajo acuerdo independiente."
        />

        <Section
          title="7. Disponibilidad del servicio"
          text="El sistema puede verse afectado por mantenimiento, infraestructura externa o servicios de terceros, por lo que no se garantiza disponibilidad continua."
        />

        <Section
          title="8. Uso adecuado del sistema"
          text="El usuario se compromete a utilizar la plataforma conforme a la normativa ecuatoriana vigente. El uso indebido podrá ocasionar la suspensión del servicio."
        />

        <Section
          title="9. Seguridad de acceso"
          text="El usuario es responsable de la custodia de sus credenciales y del uso correcto de su cuenta."
        />

        <Section
          title="10. Modificaciones del servicio"
          text="FactuSysDR podrá actualizar funcionalidades, infraestructura y condiciones cuando sea necesario para mejorar el servicio."
        />

        <Section
          title="11. Contacto"
          text="Para consultas relacionadas con estos términos puede comunicarse a contacto@factusysdr.com."
        />

      </Container>
    </Box>
  );
};

const Section = ({ title, text }) => (
  <>
    <Typography
      variant="h5"
      sx={{
        fontWeight: "bold",
        mb: 1,
        color: "#222",
      }}
    >
      {title}
    </Typography>

    <Typography sx={{ mb: 2 }}>
      {text}
    </Typography>
  </>
);

export default TermsAndConditionsPage;